import AquariusConstellation from '../assets/constellations_icons/aquarius.png';
import AriesConstellation from '../assets/constellations_icons/aries.png';
import CancerConstellation from '../assets/constellations_icons/cancer.png';
import CapricornConstellation from '../assets/constellations_icons/capricorn.png';
import GeminiConstellation from '../assets/constellations_icons/gemini.png';
import LeoConstellation from '../assets/constellations_icons/leo.png';
import LibraConstellation from '../assets/constellations_icons/libra.png';
import PiscesConstellation from '../assets/constellations_icons/pisces.png';
import SagittariusConstellation from '../assets/constellations_icons/sagittarius.png';
import ScorpioConstellation from '../assets/constellations_icons/scorpio.png';
import TaurusConstellation from '../assets/constellations_icons/taurus.png';
import VirgoConstellation from '../assets/constellations_icons/virgo.png';

export const QUALITY_MAPPING = {
  aries: {
    constellation: AriesConstellation,
    symbol: `Ram`,
    element: `Fire`,
    polarity: `Positive`,
    mode: `Cardinal`,
    rulingPlanet: `Mars`,
    rulingHouse: `First`,
    color: `Red`,
    flower: `Honeysuckle`,
    qualities: `Passionate, motivated, confident, determined`,
    celebrities: `Lady Gaga, Kourtney Kardashian, Keira Knightley`,
    careers: `Personal trainer, PR rep, entrepreneur`,
    description1: `You are an Aries. You are unwaveringly independent and determined to accomplish anything you set your mind to. At times, you may overwhelm your peers with your candid and competitive nature, but you use that to your advantage when you’re required to perform under pressure. You thrive as a leader and are able to elevate those around you through honest and insightful feedback. While your life is sometimes hectic, your unwillingness to give up constantly pushes you to new heights.`,
    description2: `The symbol of the ram signifies your willingness to drive your strongest ideas through, while the element of fire symbolizes the passion that fuels your important decisions. While your assertive nature can catch some people by surprise, it ultimately helps you accomplish lofty goals.`,
  },
  taurus: {
    constellation: TaurusConstellation,
    symbol: `Bull`,
    element: `Earth`,
    polarity: `Negative`,
    mode: `Fixed`,
    rulingPlanet: `Venus`,
    rulingHouse: `Second`,
    color: `Pink`,
    flower: `Poppy`,
    qualities: `Stubborn, gentle, fierce, opinionated, greedy`,
    celebrities: `Jessica Alba, Gal Gadot, Adele`,
    careers: `Interior designer, banker, luxury sales`,
    description1: `You are a Taurus. You are exceedingly hard-working, but you are not afraid to also enjoy the pleasures that life has to offer. Friends may sometimes see you as too set in your ways, but you are the person they think of when they need a voice of reason. You invest much of your time and energy into your romantic relationships and take pride in your constant consideration for your partner. People often rely on you for important tasks, as a keen attention to detail allows you to catch mistakes that others let pass by.`,
    description2: `The symbol of the bull signifies the headstrong way that you approach certain arguments, but your ruling planet of Venus portrays your desire to love over fighting. Although you may judge those around you too early, the confidence that you have in your values should aid you in developing lasting relationships.`,
  },
  gemini: {
    constellation: GeminiConstellation,
    symbol: `Twins`,
    element: `Air`,
    polarity: `Positive`,
    mode: `Mutable`,
    rulingPlanet: `Mercury`,
    rulingHouse: `Third`,
    color: `Yellow`,
    flower: `Lavender`,
    qualities: `Versatile, curious, witty, erratic`,
    celebrities: `Angelina Jolie, Mel B, Awkwafina`,
    careers: `Teacher, life coach, talk show host`,
    description1: `You are a Gemini. You live with a vigor and up-beat energy that many others strive for. At times, you may focus too much on acting in the way that you think people expect you to, but this is actually a testament to your emotional awareness. You are prone to boredom when working on the same task for too long, but this mindset feeds your wild imagination. Your ability to find the fun in life drives people to seek you out in a variety of social settings.`,
    description2: `The symbol of the twins signifies the conflicting inner emotions you often feel when faced with a challenging situation, while a mutable mode illustrates your willingness to change with your environment. While people have a tough time figuring you out, it is this mysterious nature that makes you so interesting. `,
  },
  cancer: {
    constellation: CancerConstellation,
    symbol: `Crab`,
    element: `Water`,
    polarity: `Negative`,
    mode: `Cardinal`,
    rulingPlanet: `Moon`,
    rulingHouse: `Fourth`,
    color: `Violet`,
    flower: `White Rose`,
    qualities: `Emotional, loyal, moody, charming`,
    celebrities: `Ariana Grande, Khloe Kardashian, Solange Knowles`,
    careers: `Doctor, social worker, nanny`,
    description1: `You are a Cancer. You are incredibly in-tune with your emotions; highly intuitive, but seldom impulsive. You are sometimes slow to open up, but you give all of yourself once you do. You have an innate sense for when a loved one is struggling with something and are usually the first one they go to during tough times because of this. You often let your mind wander and find success when letting those thoughts drive your inner creativity.`,
    description2: `The symbol of the crab signifies the emotional shell you build to try to keep people from hurting you, while the element of water symbolizes the ease with which you allow your emotions to guide your actions. While your sensitive nature can cause you to hold on to past conflicts, it also allows you to live with passion and purpose.`,
  },
  leo: {
    constellation: LeoConstellation,
    symbol: `Lion`,
    element: `Fire`,
    polarity: `Positive`,
    mode: `Fixed`,
    rulingPlanet: `Sun`,
    rulingHouse: `Fifth`,
    color: `Gold`,
    flower: `Sunflower`,
    qualities: `Self-confident, leader, protective, social`,
    celebrities: `Lisa Kudrow, Meghan Markle, Anna Kendrick`,
    careers: `Politician, actor, musician`,
    description1: `You are a Leo. You are fiercely enthusiastic and animated when it comes to the things you are most passionate about. A powerful self-assurance bolsters the presentation of your ideas, but it is important that you don’t overpower those around you.  You work well when given the freedom to do things your way and often seek out tasks that play to your strengths. Your ability to take charge of even the most trying situations inspires those around you to follow your lead.`,
    description2: `The symbol of the Lion signifies the ferocious nature with which you will defend your loved ones, while the element of fire symbolizes your bold self-expression. While your strong personality may catch certain people off-guard, it allows you to constantly live in the moment.`,
  },
  virgo: {
    constellation: VirgoConstellation,
    symbol: `Virgin`,
    element: `Earth`,
    polarity: `Negative`,
    mode: `Mutable`,
    rulingPlanet: `Mercury`,
    rulingHouse: `Sixth`,
    color: `Silver`,
    flower: `Buttercup`,
    qualities: `Communicative, modest, conscientious, helpful`,
    celebrities: `Beyoncé, Zendaya, Cameron Diaz`,
    careers: `Accountant, translator, editor`,
    description1: `You are a Virgo. You are exceptionally intelligent and well put-together. To many, you may come across as shy, but those who know you best recognize that this is just your modest nature. You stand out for your superb preparedness, which allows you to successfully balance your busy social and professional lives. Your selflessness shines through a willingness to put your family and friends before yourself, but it’s imperative that you make time for yourself too.`,
    description2: `The symbol of the virgin signifies the self-sufficiency that people attribute to your personality, while a ruling planet of Mercury reveals your deep curiosity for new experiences. While your determination for self-improvement sometimes leads you to be too hard on yourself, this will push you to do the impossible.`,
  },
  libra: {
    constellation: LibraConstellation,
    symbol: `Scales`,
    element: `Air`,
    polarity: `Positive`,
    mode: `Cardinal`,
    rulingPlanet: `Venus`,
    rulingHouse: `Seventh`,
    color: `Blue`,
    flower: `Rose`,
    qualities: `Cleverness, aesthetic, self-indulgence, good listener`,
    celebrities: `Serena Williams, Bella Hadid, Kim Kardashian West`,
    careers: `Lawyer, guidance counselor, wedding planner`,
    description1: `You are a Libra. You have an admirable tact and open-mindedness that allows you to build strong relationships with vastly different people. You sometimes have difficulty staying focused on one task at a time, but this lets you work on projects that connect multiple complex ideas. Your intelligence and quick-wit lend well to a good sense of humor, which often comes out when meeting new people. Although you tend to focus on learning more about those around you, it is important for you to first determine the attributes that make you unique.`,
    description2: `The symbol of the scale signifies your desire to successfully find balance in your life, while the element of air symbolizes your inclination to drift between tasks and ideas. Despite a reputation for sometimes being aloof, your ability to empathize with the people closest to you is ultimately what they appreciate most about you.`,
  },
  scorpio: {
    constellation: ScorpioConstellation,
    symbol: `Scorpion`,
    element: `Water`,
    polarity: `Negative`,
    mode: `Fixed`,
    rulingPlanet: `Mars & Pluto`,
    rulingHouse: `Eighth`,
    color: `Black`,
    flower: `Geranium`,
    qualities: `Passionate, turbulent, obsessive, vengeful`,
    celebrities: `Katy Perry, Lorde, Kendall Jenner`,
    careers: `Psychologist, massage therapist, fertility specialist`,
    description1: `You are a Scorpio. You are extremely strong-willed and true to yourself. At times, you may come across as a little aggressive, but this is just due to your unparalleled intensity. The dedication you give to even the most insignificant tasks is difficult for both superiors and peers to overlook. You are not afraid to be the “bad guy” if you think it’s necessary, which is why your friends come to you when they need an honest opinion.`,
    description2: `The symbol of the scorpion signifies the sharp edge you give off towards those that wrong you, while your fixed mode signifies your affinity to stay with what you know. Although your sometimes-unconventional views make you stand out, your differing perspective allows for colleagues’ best ideas to come to the surface.`,
  },
  sagittarius: {
    constellation: SagittariusConstellation,
    symbol: `Archer`,
    element: `Fire`,
    polarity: `Positive`,
    mode: `Mutable`,
    rulingPlanet: `Jupiter`,
    rulingHouse: `Ninth`,
    color: `Purple`,
    flower: `Carnation`,
    qualities: `Optimistic, honest, adventurous, independent`,
    celebrities: `Taylor Swift, Chrissy Teigen, Tiffany Haddish`,
    careers: `Travel agent, writer, youth program leader`,
    description1: `You are a Sagittarius. You are wonderfully inventive and highly expressive. In many ways, you are an open book, which makes people feel especially close to you. Although you sometimes come off as inflexible, this is only because you prefer to think deeply about a situation instead of acting rashly. You are most successful when given the freedom to work on every stage of a project so that you can ensure that your creative vision is completely realized. The strong understanding you have of yourself enables you to approach challenges in ways that best suit you.`,
    description2: `The symbol of the archer signifies how you set your sights and fully devote yourself to complicated undertakings, while your ruling planet of Jupiter symbolizes your vast knowledge in myriad subjects. Your yearning for adventure will likely lead you to many exotic places, but remember to stay emotionally close to those at home too.`,
  },
  capricorn: {
    constellation: CapricornConstellation,
    symbol: `Goat`,
    element: `Earth`,
    polarity: `Negative`,
    mode: `Cardinal`,
    rulingPlanet: `Saturn`,
    rulingHouse: `Tenth`,
    color: `Gray`,
    flower: `Pansy`,
    qualities: `Ambitious, realistic, sensitive, disciplined`,
    celebrities: `Michelle Obama, Kate Middleton, Regina King`,
    careers: `Architect, engineer, real estate agent`,
    description1: `You are a Capricorn. You are remarkably detail-oriented and quite ambitious. You often put a lot of pressure on yourself to succeed beyond expectations, but this helps you create extraordinary pieces of work. You take a strong sense of responsibility for your actions, which makes people feel comfortable giving you constructive criticism. Your firm practicality allows you to avoid making poor, near-sighted decisions that many others fall victim to.`,
    description2: `The symbol of the goat signifies the stubbornness you have for finishing something that you’ve started, while the element of earth signifies your ability to ground yourself when your patience is severely tested. Your aim for perfection drives your success, but remember that things will not always go exactly how you want them to – and that’s ok!`,
  },
  aquarius: {
    constellation: AquariusConstellation,
    symbol: `Water-Bearer`,
    element: `Air`,
    polarity: `Positive`,
    mode: `Fixed`,
    rulingPlanet: `Uranus`,
    rulingHouse: `Eleventh`,
    color: `Turquoise`,
    flower: `Orchid`,
    qualities: `Assertive, analytical, eccentric, easy going`,
    celebrities: `Alicia Keys, Kerry Washington, Shakira`,
    careers: `Graphic designer, journalist, activist`,
    description1: `You are an Aquarius. You possess a level of humility and compassion that leads you to help others without thinking about your personal image. At times, you are hard to pin down, but this is because you are such a hot commodity among your friends. You are tirelessly committed to making a positive difference on the world and are willing to donate the time and energy required to see results. Your unique approach to problem-solving makes you a valuable asset to any homogenous team, which is where your talents can really shine through.`,
    description2: `The symbol of the water-bearer signifies your supportive nature, while your ruling planet of Uranus signifies the artistic spirit you use to challenge the status quo. Although your philosophies may come across as unrealistic to some, it is this mentality that grants you truly novel ideas.`,
  },
  pisces: {
    constellation: PiscesConstellation,
    symbol: `Two Fish`,
    element: `Water`,
    polarity: `Negative`,
    mode: `Mutable`,
    rulingPlanet: `Neptune`,
    rulingHouse: `Twelfth`,
    color: `Sea foam`,
    flower: `Water Lily`,
    qualities: `Empathetic, impressionable, imaginative, romantic`,
    celebrities: `Rihanna, Drew Barrymore, Lupita Nyong'o`,
    careers: `Filmmaker, artist, therapist`,
    description1: `You are a Pisces. You have a profound perceptiveness and understanding for the important people in your life. While you may initially come off as quiet, this is because you are typically deep in-thought about the conversations going on around you. Your ability to easily put yourself in someone else’s shoes during personal conflicts comes from your strong emotional insight. You enjoy expressing yourself through creative outlets and use this as a way to relieve stress and try out new ideas.`,
    description2: `The symbol of the two fish signifies the battle that exists between your inner thoughts and outer actions, while your ruling planet of Neptune signifies your desire to let your imagination drive your ideas. The generosity and care that you have for your friends and family is commendable, but be weary of being taken for granted.`,
  },
};
